import { render, staticRenderFns } from "./TwoWork.vue?vue&type=template&id=3e0aa7d6&scoped=true"
import script from "./TwoWork.vue?vue&type=script&lang=js"
export * from "./TwoWork.vue?vue&type=script&lang=js"
import style0 from "./TwoWork.vue?vue&type=style&index=0&id=3e0aa7d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0aa7d6",
  null
  
)

export default component.exports